module.exports = __webpack_public_path__ + "static/media/RG.d2497015.svg";